var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTradeMate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_9574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71289 23.2973C6.71289 23.6286 6.98152 23.8973 7.31289 23.8973H23.2504C23.5818 23.8973 23.8504 23.6286 23.8504 23.2973V2.57852C23.8504 1.21164 22.7423 0.103516 21.3754 0.103516H5.43789C5.10652 0.103516 4.83789 0.372145 4.83789 0.703516C4.83789 1.03489 5.10652 1.30352 5.43789 1.30352C6.14207 1.30352 6.71289 1.87436 6.71289 2.57852V23.2973ZM7.55965 1.30352H21.3754C22.0796 1.30352 22.6504 1.87436 22.6504 2.57852V22.6973H7.91289V2.57852C7.91289 2.11215 7.7839 1.6759 7.55965 1.30352Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55664 11.016C1.55664 11.3474 1.82527 11.616 2.15664 11.616H7.31289C7.64426 11.616 7.91289 11.3474 7.91289 11.016V2.57852C7.91289 1.21164 6.80483 0.103516 5.43789 0.103516C4.07095 0.103516 2.96289 1.21164 2.96289 2.57852V9.60977C2.96289 10.055 2.60189 10.416 2.15664 10.416C1.82527 10.416 1.55664 10.6846 1.55664 11.016ZM3.9943 10.416C4.10271 10.1693 4.16289 9.89655 4.16289 9.60977V2.57852C4.16289 1.87436 4.73371 1.30352 5.43789 1.30352C6.14207 1.30352 6.71289 1.87436 6.71289 2.57852V10.416H3.9943Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.150391 9.60977C0.150391 10.7178 1.04864 11.616 2.15664 11.616C3.26464 11.616 4.16289 10.7178 4.16289 9.60977V3.51602C4.16289 3.18465 3.89426 2.91602 3.56289 2.91602H0.750391C0.41902 2.91602 0.150391 3.18465 0.150391 3.51602V9.60977ZM2.15664 10.416C1.71139 10.416 1.35039 10.055 1.35039 9.60977V4.11602H2.96289L2.96289 9.60977C2.96289 10.055 2.60189 10.416 2.15664 10.416Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52539 8.67227C9.52539 9.00364 9.79402 9.27227 10.1254 9.27227H20.4379C20.7693 9.27227 21.0379 9.00364 21.0379 8.67227V3.51602C21.0379 3.18465 20.7693 2.91602 20.4379 2.91602H10.1254C9.79402 2.91602 9.52539 3.18465 9.52539 3.51602V8.67227ZM10.7254 8.07227V4.11602H19.8379V8.07227H10.7254Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52539 17.5785C9.52539 17.9099 9.79402 18.1785 10.1254 18.1785H15.7504C16.0818 18.1785 16.3504 17.9099 16.3504 17.5785C16.3504 17.2471 16.0818 16.9785 15.7504 16.9785H10.7254V11.4848C10.7254 11.1534 10.4568 10.8848 10.1254 10.8848C9.79402 10.8848 9.52539 11.1534 9.52539 11.4848V17.5785Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5136 15.1903C12.7479 15.4246 13.1278 15.4246 13.3622 15.1903L16.6434 11.909C16.8777 11.6747 16.8777 11.2948 16.6434 11.0605C16.4091 10.8262 16.0292 10.8262 15.7949 11.0605L12.5136 14.3418C12.2793 14.5761 12.2793 14.956 12.5136 15.1903Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2191 14.4285C16.5505 14.4285 16.8191 14.1599 16.8191 13.8285V11.4848C16.8191 11.1534 16.5505 10.8848 16.2191 10.8848H13.8754C13.544 10.8848 13.2754 11.1534 13.2754 11.4848C13.2754 11.8161 13.544 12.0848 13.8754 12.0848H15.6191V13.8285C15.6191 14.1599 15.8878 14.4285 16.2191 14.4285Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9629 14.766C17.9629 15.0974 18.2315 15.366 18.5629 15.366H20.4379C20.7693 15.366 21.0379 15.0974 21.0379 14.766C21.0379 14.4346 20.7693 14.166 20.4379 14.166H18.5629C18.2315 14.166 17.9629 14.4346 17.9629 14.766Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9629 17.5785C17.9629 17.9099 18.2315 18.1785 18.5629 18.1785H20.4379C20.7693 18.1785 21.0379 17.9099 21.0379 17.5785C21.0379 17.2471 20.7693 16.9785 20.4379 16.9785H18.5629C18.2315 16.9785 17.9629 17.2471 17.9629 17.5785Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52539 20.391C9.52539 20.7224 9.79402 20.991 10.1254 20.991H20.4379C20.7693 20.991 21.0379 20.7224 21.0379 20.391C21.0379 20.0596 20.7693 19.791 20.4379 19.791H10.1254C9.79402 19.791 9.52539 20.0596 9.52539 20.391Z",
    fill: "#8F8F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_9574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeMate);
export default __webpack_public_path__ + "static/media/TradeMate.102c8363d8397ebbe1fdb2a7223a740c.svg";
export { ForwardRef as ReactComponent };